import React, { useCallback, useEffect, useState } from "react";
import {
  AgriProductsAPMC,
  AmendmentStaffMarketCommittee,
  AppointmentSecretaryAPMC,
  BuyingLandAPMC,
  ContractualAppointmentSecretaryAPMC,
  PayComission,
  PermAppointmentSecretaryAPMC,
  PromotionSecretaryMarketCommittee,
  ProposalDonation,
  ProposalLoan,
  SellingLandAPMC,
  StudyTour,
  YardAPMC,
} from "../Json/AllData";
import CommonSelect, { Option } from "./commonSelect";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { roleOptions } from "../../../../core/data/json/role";
import SingleView from "../../allPages/components/SingleForm";
import {
  queryFormApplication,
  submitApmcApproveRejectApplication,
  updateField,
} from "../../../auth/services/privateapicalling";
import ApplicationTimelineModal from "./ApplicationTimeLineModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ActionButtons from "./ActionButtons";
import { toast, ToastContainer } from "react-toastify";
import DownloadFormApplication from "./DownloadForm";
import { Certificate10, Certificate11, Certificate12, Certificate13, Certificate7, Certificate8, Certificate9, Certificates1, Certificates2, Certificates3, Certificates4, Certificates5, Certificates6 } from "./CertificatesForm";

interface Page1Props {
  onNext: () => void;
  onBack: () => void;
  type: string | null;
  handleFileChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    documentName
  ) => void;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    fieldName
  ) => void;
  formData: Record<string, any>;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  existData: any;
  applicationId: any;
  transaction: any;
  formType: any;
  editFieldValues: any;
  setEditFieldValues: any;
  editFiles: any;
  setEditFiles: any;
  getExistedApplication: () => void;
  uploadLoading: boolean;
}

const Page1 = ({
  formData,
  setFormData,
  handleFileChange,
  handleInputChange,
  editFieldValues,
  setEditFieldValues,
  editFiles,
  setEditFiles,
  type,
  existData,
  applicationId,

  transaction,
  getExistedApplication,
  uploadLoading
}: Page1Props) => {
  const navigate = useNavigate();
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail.Role.Role_Identifier;
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  const [comment , setComment] = useState<string>("");
  // State variables for form management
  const [verified, setVerified] = useState<{ [key: string]: boolean }>({});
  const [updatedIndexes, setUpdatedIndexes] = useState<number[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [ActionRequired, setActionRequired] = useState<string[]>([]);
  const [fieldComments, setFieldComments] = useState<{ [key: string]: string }>(
    {}
  );
  const [fieldCommentSubmitted, setFieldCommentSubmitted] = useState<{ [key: string]: string }>(
    {}
  );

  const [certificateData, setCertificateData] = useState({
    positionName: existData?.positionName || "",
    FilledFormName: existData?.FilledFormName || "",
  })
  const [pendingVerified, setPendingVerified] = useState<{ [key: string]: boolean }>({});
  // Log overlay states
  const [logFieldKey, setLogFieldKey] = useState<string | null>(null);
  const [showLogOverlay, setShowLogOverlay] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const [check, setCheck] = useState(false);
  const [issued, setIssued] = useState(false);

  // Set issued to true when roleIdentifier matches, using useEffect
  useEffect(() => {
    if (roleIdentifier === "SC" || roleIdentifier === "HOS" || roleIdentifier === "DT" || roleIdentifier === "DY" ||roleIdentifier==="SA") {
      setIssued(true);
   
      setCertificateData(prevData => ({
        ...prevData,
        FilledFormName: existData?.FilledFormName || "",
        positionName: existData?.positionName || ""
      }));

    }
  }, [roleIdentifier]);
  const [checkerr, setCheckerr] = useState(false);
  // Add this with your other state variables
  const [updatedFields, setUpdatedFields] = useState<{ [key: string]: any }>(
    {}
  );

  // Add this useEffect for managing body overflow when overlay is shown
  useEffect(() => {
    if (showLogOverlay) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showLogOverlay]);


  let heading = "";

  const getCertificates = () => {
  
    const typeNum = Number(type);
   
    switch (typeNum) {
      case 39:
        return (
          <div>
            {existData && applicationId && <Certificates1 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 40:
        return (
          <div>
            {existData && applicationId && <Certificates2 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 41:
        return (
          <div>
            {existData && applicationId && <Certificates3 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 42:
        return (
          <div>
            {existData && applicationId && <Certificates4 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 43:
        return (
          <div>
            {existData && applicationId && <Certificates5 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 44:
        return (
          <div>
            {existData && applicationId && <Certificates6 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 45:
        return (
          <div>
            {existData && applicationId && <Certificate7 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 46:
        return (
          <div>
            {existData && applicationId && <Certificate8 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 47:
        return (
          <div>
            {existData && applicationId && <Certificate9 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 48:
        return (
          <div>
            {existData && applicationId && <Certificate10 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 49:
        return (
          <div>
            {existData && <Certificate11 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 50:
        return (
          <div>
            {existData && applicationId && <Certificate12 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );
      case 51:
        return (
          <div>
            {existData && applicationId && <Certificate13 apmcName={existData?.department?.apmcName} districtName={existData?.department?.District} check={check} setCheck={setCheck} issued={issued} certificateData={certificateData} setCertificateData={setCertificateData} />}
          </div>
        );

    }
  };
  const getDataField = () => {
    
    const typeNum = Number(type);
   
    switch (typeNum) {
      case 39:
        heading = "Buying Land";
        return BuyingLandAPMC;
      case 40:
        heading = "Selling Land";
        return SellingLandAPMC;
      case 41:
        heading =
          "To control Agriculture products under the APMC - Application under Form-8";
        return AgriProductsAPMC;
      case 42:
        heading = "Declaration of the main yard/sub-yard of APMC";
        return YardAPMC;
      case 43:
        heading =
          " the new/permanent or temporary appointment of the Secretary in the Market Committee";
        return AppointmentSecretaryAPMC;
      case 44:
        heading = "Permanent appointment of Secretary in the Market Committee";
        return PermAppointmentSecretaryAPMC;
      case 45:
        heading =
          "Regarding amendment in the staff schedule of the Market Committee";
        return AmendmentStaffMarketCommittee;
      case 46:
        heading =
          "Regarding promotion from Assistant Secretary / Inspector to Secretary in the Market Committee";
        return PromotionSecretaryMarketCommittee;
      case 47:
        heading =
          "Regarding contractual appointment of Secretary / employee after retirement";
        return ContractualAppointmentSecretaryAPMC;
      case 48:
        heading =
          "Regarding approval of 7th Pay Commission for Secretary / employee";
        return PayComission;
      case 49:
        heading = " Proposals regarding donation";
        return ProposalDonation;
      case 50:
        heading = "Proposals regarding loan";
        return ProposalLoan;
      case 51:
        heading = "Approval for Study Tours";
        return StudyTour;
      default:
        return BuyingLandAPMC;
    }
  };

  const dataField = getDataField();

  const selectFn = (response: any) => {
    const options = [
      { value: "option1", label: "Option 1" },
      { value: "option2", label: "Option 2" },
    ];

    const handleChange = (selectedOption: Option | null, fieldName: string) => {
      setFormData((prev) => {
        const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
        const index = arr.findIndex((item) => item.fieldName === fieldName);
        if (index !== -1) {
          arr[index] = { ...arr[index], value: selectedOption?.value || "" };
        } else {
          arr.push({
            value: selectedOption?.value || "",
            fieldName: fieldName,
          });
        }
        return { ...prev, [fieldName]: arr };
      });
    };

    const selectedValue = options.find(
      (opt) => opt.value === formData[response?.responseVal]
    );

    return (
      <CommonSelect
        options={options}
        value={selectedValue}
        name={response?.responseVal}
        onChange={(e) => handleChange(e, response?.fieldName)}
        placeholder={`Select ${response?.responseVal}`}
        className="w-100"
      />
    );
  };

  const inputFn = (response: any) => {
    return (
      <input
        type="text"
        className="p-2 form-control"
        placeholder={`Enter ${response?.responseVal}`}
        name={response?.responseVal}
        value={
          existData?.annexureOne?.[response?.fieldName]?.data?.find(
            (item) => item.fieldName === response?.responseVal
          )?.value || ""
        }
        onChange={(e) => handleInputChange(e, response?.fieldName)}
        disabled={true}
      />
    );
  };

  const numberFn = (response: any) => {
    return (
      <input
        type="number"
        className="p-2 form-control"
        placeholder={`Enter ${response?.responseVal}`}
        name={response?.responseVal}
        value={
          existData?.annexureOne?.[response?.fieldName]?.data?.find(
            (item) => item.fieldName === response?.responseVal
          )?.value || ""
        }
        onChange={(e) => handleInputChange(e, response?.fieldName)}
        disabled={true}
      />
    );
  };

  const radioFn = (response: any) => {
    // Only use existData for checked value, never editFieldValues
    const checkedValue = existData?.annexureOne?.[response?.fieldName]?.data?.find(
      (item) => item.fieldName === response?.responseVal
    )?.value;
    return (
      <div className="d-flex w-100 gap-2">
        <input
          type="radio"
          name={"readonly-" + response?.responseVal}
          value="yes"
          disabled
          checked={checkedValue === "yes"}
          tabIndex={-1}
        />{" "}
        Yes
        <input
          type="radio"
          name={"readonly-" + response?.responseVal}
          value="no"
          disabled
          checked={checkedValue === "no"}
          tabIndex={-1}
        />{" "}
        No
      </div>
    );
  };

  const percentageFn = (response: any) => (
    <input
      className="form-control"
      type="text"
      inputMode="decimal"
      name={response?.responseVal}
      placeholder="0 - 100"
      value={
        existData?.annexureOne?.[response?.fieldName]?.find(
          (item) => item.fieldName === response?.responseVal
        )?.value || ""
      }
      onChange={(e) => handleInputChange(e, response?.fieldName)}
      disabled={true}
    />
  );
  const dateFn = (response: any) => {
    return (
      <div className="d-flex flex-column">
        <input
          type="date"
          className={`p-2 form-control  ? 'border border-danger' : ''}`}
          name={response?.responseVal}
          value={
            existData?.annexureOne?.[response?.fieldName]?.data?.find(
              (item) => item.fieldName === response?.responseVal
            )?.value || ""
          }
          onChange={(e) => {
            handleInputChange(e, response?.fieldName);
          }}
          disabled={true}
        />

        <small className="text-muted mt-1 ms-1">{response.responseName}</small>
      </div>
    );
  };
  const fileFn = (response: any) => (
    <input
      className="form-control"
      type="file"
      onChange={(e) => handleFileChange(e, response?.fieldName)}
      name={response?.responseVal}
      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
      id={response?.responseVal}
    />
  );

  const fileButtonFn = (fieldName, docName) => {
    const docData = existData?.annexureOne?.[fieldName];
    const docId = docData?.data.find(
      (data) => data.documentName == docName
    )?.docId;

    return (
      <Link
        to="#"
        data-bs-toggle="modal"
        data-inert={true}
        data-bs-target="#apmc_modal"
        className="btn btn-outline-info w-100"
        onClick={() => {
          setSelectedDocId(docId);
        }}
      >
        <i className="ti ti-eye"></i> View Document
      </Link>
    );
  };

  const handleViewLogClick = (fieldKeys: string[] | string) => {
    let duplicateDataRemover = Array.from(new Set(fieldKeys));
  
    const keys = Array.isArray(duplicateDataRemover)
      ? duplicateDataRemover
      : [duplicateDataRemover];

    const transactionData = keys.map((key) => ({
      key,
      data: existData.annexureOne?.[key]?.transaction || [],
    }));
  
    setTransactionData(transactionData);
    setLogFieldKey(keys.join(", "));
    setShowLogOverlay(true);
  };

  const handleCloseOverlay = () => {
    setShowLogOverlay(false);
  };

  const handleFinalSubmit = async (status, appStatusLevel) => {
    try {
      setSubmitLoading(true);
   
      const missingActions: string[] = [];

      // Loop through each field in your JSON
      if(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission")
   {   dataField?.forEach((field, index) => {
        const fieldKey = field.fieldName; // unique key per field
        const fieldNo = parseInt(field.fieldNo) - 1;
        const isVerified = !!verified[fieldNo]; // check against verified object// true if verified
        const isUpdated = updatedIndexes.includes(index); // updated by index
        const hasComment = fieldCommentSubmitted[fieldKey]?.trim()?.length > 0;
        if (!isVerified && !isUpdated && !hasComment) {
          missingActions.push(fieldKey);
        }
      });

      // Prevent raise query if all fields are verified for Dr, DT, DY
      if ((["Dr", "DT", "DY"].includes(roleIdentifier) && status === "reject") || (roleIdentifier === "DT" && status === "permanentReject")) {
        const allVerified = dataField.every((field, index) => {
          const fieldNo = parseInt(field.fieldNo) - 1;
          return !!verified[fieldNo];
        });
        if (allVerified) {
          if (status === "reject") {
            toast.error("All fields are verified. You cannot raise a query.", {
              position: "top-right",
              style: { fontSize: "1.2rem", padding: "16px" },
            });
          } else {
            toast.error("All fields are verified. You cannot permanently reject.", {
              position: "top-right",
              style: { fontSize: "1.2rem", padding: "16px" },
            });
          }
          return;
        }
      }

      if (missingActions.length > 0) {
        setActionRequired(missingActions);
        return; // ❌ Stop submit
      }}

      if (roleIdentifier === "Dr" && status !== "reject") {
        if (!check) {

          setCheckerr(true);
          return;
        } else {
          setCheckerr(false);
        }

        if (existData?.scheme?.id === 40 || existData?.scheme?.id === 42) {
          if (!certificateData.FilledFormName || !certificateData.positionName) {
            toast.error("Please fill in all certificate details.", {
              position: "top-right",
              style: { fontSize: "1.2rem", padding: "16px" },
            });
            return;
          }
        }
        if (existData?.scheme?.id === 39) {
          if (!certificateData.FilledFormName) {
            toast.error("Please fill in all certificate details.", {
              position: "top-right",
              style: { fontSize: "1.2rem", padding: "16px" },
            });
            return;
          }
        }
      }


      const formData = {
        comment: comment,
        status: status,
        applicationType: "form",
        appStatusLevel: appStatusLevel,
        applicationId: applicationId,
        schemeId: existData?.scheme?.id,
        ...((roleIdentifier === "Dr") && {
          positionName: certificateData.positionName,
          FilledFormName: certificateData.FilledFormName,

        }),

      };

      const submitData = await submitApmcApproveRejectApplication(
        formData,
        token
      );

      if (submitData?.success) {
        setActionRequired([]);
        if (submitData?.data?.status === "reject") {

          // alert("!");
          toast.success(
            <>
              Raised-Query successfully <br /> પ્રશ્ન સફળતાપૂર્વક ઉઠાવવામાં
              આવ્યો
            </>,
            {
              position: "top-right",
              style: { fontSize: "1.2rem", padding: "16px" },
            }
          );
        } else if (submitData?.data?.status === "permanentReject") {
          // alert("Application permanently rejected!");
          toast.info(
            <>
              Application permanently rejected <br /> અરજી કાયમી ધોરણે નકારી
              કાઢવામાં આવી
            </>,
            {
              position: "top-right",
              style: { fontSize: "1.2rem", padding: "16px" },
            }
          );
        } else if (submitData?.data?.status === "approvedUnsigned") {
          // alert("Application Approved!");
          toast.success(
            <>
              Application Approved <br /> અરજી મંજૂર
            </>,
            {
              position: "top-right",
              style: { fontSize: "1.2rem", padding: "16px" },
            }
          );
        }
        else {
          
          toast.success(
            <>
              Form submitted successfully <br /> ફોર્મ સફળતાપૂર્વક સબમિટ કર્યું
            </>,
            {

              style: { fontSize: "1.2rem", padding: "16px" },
            }
          );
        }
        setTimeout(() => {
          navigate("/apmc-forms-application");
        }, 1000);
      } else {
        // alert("Submission failed, please try again.");
        toast.error(
          <>
            Submission failed, please try again <br />
            સબમિશન નિષ્ફળ ગયું, કૃપા કરીને ફરી પ્રયાસ કરો
          </>,
          {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" },
          }
        );
      }
    } catch (error) {
    
    } finally {
      setSubmitLoading(false);
    }
  };

  // Handle verify button - NO VALIDATION
  const handleVerifiedChange = (fieldIndex: string) => {
    setPendingVerified((prev) => ({
      ...prev,
      [fieldIndex]: !prev[fieldIndex],
    }));
  };

  // Add this new function after your existing handler functions
  const handleUpdateSubmit = async (index: number, responses: any[]) => {

 
    const isVerified = pendingVerified[index] === true ? true : false;
   
    setVerified((prev) => ({
      ...prev,
      [index]: isVerified,
    }));
    const oldValue: any[] = [];
    const newValue: any[] = [];
    const field = responses.find((res) => res?.fieldName)?.fieldName
      ? responses.find((res) => res?.fieldName)?.fieldName
      : responses.find((res) => res.responseVal)?.responseVal;
   
    // Build oldValue and newValue using editFieldValues and editFiles
    const fieldDataArray = existData?.annexureOne?.[field]?.data;
    
    if (Array.isArray(fieldDataArray)) {
      // Handle input/text fields (editFieldValues: Record<string, Array<Record<string, any>>>)
      Object.entries(editFieldValues).forEach(([fieldKey, updatedArr]: any) => {
        // updatedArr is an array of objects, each with { fieldName, value }
        if (Array.isArray(updatedArr)) {
          updatedArr.forEach((updatedObj: any) => {
            // Old value: get previous value from existData
            const previousField = fieldDataArray.find(
              (item: any) => item?.fieldName === updatedObj.fieldName
            );
            if (previousField) {
              oldValue.push({
                fieldValue: previousField?.value || "",
                fieldName: updatedObj.fieldName,
                fieldType: "string",
              });
            }
            // New value: use updated value
            newValue.push({
              fieldValue: updatedObj.value,
              fieldName: updatedObj.fieldName,
              fieldType: "string",
            });
          });
        }
      });

      // Handle document fields (editFiles: Record<string, Array<Record<string, any>>>)
      Object.entries(editFiles).forEach(([fieldKey, fileArr]: any) => {
        // fileArr is an array of objects, each with { documentName, docId }
        if (Array.isArray(fileArr)) {
          fileArr.forEach((fileObj: any) => {
            // Old value: get previous docId for this documentName (not fieldName)
            const previousDoc = fieldDataArray.find(
              (item: any) => item?.documentName === fileObj?.documentName
            );
            if (previousDoc) {
              oldValue.push({
                fieldValue: previousDoc.docId || "",
                fieldName: previousDoc?.documentName,
                fieldType: "doc",
              });
            }
            // New value: use docId if available, else null
            newValue.push({
              fieldValue: fileObj?.docId || null,
              fieldName: fileObj?.documentName,
              fieldType: "doc",
            });
          });
        }
      });
    }


    // Determine if field is updated (oldValue and newValue differ)
    let isUpdated = JSON.stringify(oldValue) !== JSON.stringify(newValue);
    isUpdated = newValue.length !== 0 ? true : false;
    if (isUpdated && !(fieldComments[responses[0]?.fieldName])) {
      toast.error("Please add comment also if you want to update the field",
        {
          position: "top-right",
          style: { fontSize: "1.2rem", padding: "16px" },
        })
      return;

    }
    const transaction = [
      {
        oldValue,
        newValue,
        transactionBy: roleIdentifier,
        status: existData.status,
        appStatusLevel: existData.appStatusLevel,
      },
    ];

    const payload = {
      couchId: existData?.applicationDataId,
      fieldUpdated: field,
      isVerified: isUpdated ? false : isVerified,
      isUpdated: isUpdated,
      comment: fieldComments[responses[0]?.fieldName]
        ? fieldComments[responses[0]?.fieldName]
        : "",
      applicationType: "form",
      annexureUpdated: "annexureOne",
      [`${field}`]: {
        transaction,
      },
    };

    

    try {
      const submitTransaction = await updateField(payload, token);
   

      if (submitTransaction?.result?.ok) {
        if (isUpdated) {
          setUpdatedIndexes((prev) => [...prev, index]);
        }
        setEditingIndex(null);
        setFieldCommentSubmitted((prev) => ({
          ...prev,
          [responses[0]?.fieldName]: fieldComments[responses[0]?.fieldName]
        }))
        setFieldComments((prev) => ({
          ...prev,
          [responses[0]?.fieldName]: "",
        }));
        setUpdatedFields({});
        setEditFieldValues({});
        setEditFiles({});

        getExistedApplication();

        toast.success(
          <>
            Field Transaction submitted successfully <br />
            ફીલ્ડ સફળતાપૂર્વક સબમિટ કરવામાં આવ્યું
          </>,
          {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" },
          }
        );
      } else {
        
        setUpdatedFields({});
        // alert('Update failed. Please try again.');
        toast.error(
          <>
            Update failed. Please try again <br />
            અપડેટ નિષ્ફળ થયું. કૃપા કરીને ફરી પ્રયાસ કરો.
          </>,
          {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" },
          }
        );
      }
    } catch (error) {
   
      setEditingIndex(null);

      setFieldComments((prev) => ({ ...prev, [responses[0]?.fieldName]: "" }));
      setUpdatedFields({});
      setEditFieldValues({});
      setEditFiles({});
      // alert('An error occurred during update. Please try again.');
      toast.success(
        <>
          An error occurred during update. Please try again <br />
          અપડેટ દરમિયાન એક ભૂલ આવી. કૃપા કરીને ફરી પ્રયાસ કરો.
        </>,
        {
          position: "top-right",
          style: { fontSize: "1.2rem", padding: "16px" },
        }
      );
    }
  };



  // Handler functions for ActionButtons
  const handleEditingToggle = (index: number) => {
    setEditingIndex(index === -1 ? null : index);
  };

  const handleCommentChange = useCallback(
    (fieldName: string, comment: string) => {
      setFieldComments((prev) => ({ ...prev, [fieldName]: comment }));
    },
    []
  );
  function buildResponseMap(jsonData) {
    return jsonData
      .flatMap(field => field.response)
      .reduce((acc, resp) => {
        acc[resp.responseVal] = resp.responseName;
        return acc;
      }, {});
  }
  const responseMap = buildResponseMap(dataField);

 const handleDirector = async (fieldsToUpdate: any[]) => {
    try {
      if (!fieldsToUpdate || fieldsToUpdate.length === 0) return;
   setSubmitLoading(true);
      const payload = {
        couchId: existData?.applicationDataId,
        applicationType: "form",
        fieldsToUpdate: fieldsToUpdate
      };

      

      // Call the API
      const response = await queryFormApplication(payload, token);

      if (response?.success) {
       toast.success(
          <>
            Field updated  successfully <br />
        ક્ષેત્ર સફળતાપૂર્વક અપડેટ થયું
          </>,
          {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" },
          }
        ); 
      
      } else {
      
      }
        
    } catch (error) {
  
     
    } finally {
    setSubmitLoading(false)
    }
  };
  useEffect(() => {


    if (!existData || !existData.annexureOne || !dataField) return;

    const newVerified: { [key: number]: boolean } = {};
    const newUpdatedIndexes: number[] = [];
    const newComments: { [key: string]: string } = {};

    dataField.forEach((item, index) => {
      let isVerifiedForRole = false;
      let isUpdatedForRole = false;
      let commentForRole: string | null = null;

      item.response.forEach((r) => {
        const reSubmittedFieldsData = existData?.apmcSchemeTransaction?.rejectedFields?.rejectedFieldsData?.annexureOne;
        const transactions = existData.annexureOne?.[r.fieldName]?.transaction || [];
        let lastRoleTx = null;
        if (reSubmittedFieldsData && Object.prototype.hasOwnProperty.call(reSubmittedFieldsData, r.fieldName)) {
          // If resubmitted field, only set lastRoleTx if the last transaction is for this role
          if (transactions.length > 0) {
            const lastTx = transactions[transactions.length - 1];
            if (lastTx.transactionBy === roleIdentifier) {
              lastRoleTx = lastTx;
            }
          }
        } else {
          // Not a resubmitted field: filter by role as before
          lastRoleTx = transactions.filter(
            (tx) => tx.transactionBy === roleIdentifier
          ).pop();
        }

        if (lastRoleTx) {
          if (lastRoleTx.isVerified === true) {
            isVerifiedForRole = true;
          }
          if (lastRoleTx.isUpdated === true) {
            isUpdatedForRole = true;
          }
          if (lastRoleTx.comment) {
            commentForRole = lastRoleTx.comment;
          }
        }
      });

      if (isVerifiedForRole) {
        newVerified[index] = true;
      }
      if (isUpdatedForRole) {
        newUpdatedIndexes.push(index);
      }
      if (commentForRole) {
        newComments[item.fieldName] = commentForRole;
      }
    });

    setVerified(newVerified);
    setPendingVerified(newVerified);
    setUpdatedIndexes(newUpdatedIndexes);
    setFieldComments(newComments)
  }, [existData, roleIdentifier, dataField]);

  // Effect for Director role to show fields verified by Deputy Director on first render
  useEffect(() => {
    if (!existData || !existData.annexureOne || !dataField || !roleIdentifier) return;
   
       const isDirector = roleIdentifier === "DT";
       const isDistrictRegistrar = roleIdentifier === "Dr";
       if (!isDirector && !isDistrictRegistrar) return;
   
       const newVerified: { [key: number]: boolean } = {};
       const verifiedFieldsToUpdate: any[] = [];
   
       // Director should auto-verify fields verified by Deputy Director (DY)
       // District Registrar should auto-verify fields verified by Committee (COM)
       const verifierRoleIdentifier = isDirector ? "DY" : "COM";
   
       dataField.forEach((item, index) => {
         let isVerifiedByPrevious = false;
   
         item.response.forEach((r) => {
           const transactions = existData.annexureOne?.[r.fieldName]?.transaction || [];
   
           const prevVerified = transactions.some(
             (tx) => tx.transactionBy === verifierRoleIdentifier && tx.isVerified === true
           );
   
           if (prevVerified) {
             isVerifiedByPrevious = true;
           }
         });
   
         if (isVerifiedByPrevious) {
           newVerified[index] = true;
   
           verifiedFieldsToUpdate.push({
             fieldUpdated: item.fieldName,
             annexureUpdated: "annexureOne",
             newTransaction: {
               transactionBy: userDetail?.Role?.Role_Identifier,
               status: "pending",
               appStatusLevel: existData.appStatusLevel,
               newValue: []
             },
             isVerified: true,
             isUpdated: false,
             comment: ""
           });
         }
      setVerified(newVerified);
    setPendingVerified(newVerified);
    });
    
    handleDirector(verifiedFieldsToUpdate);

    // Only set on first render for Director
   
  }, []); // Empty dependency array to run only on first render

  return (
    <>

      {submitLoading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.3)", zIndex: 1050 }}>
          <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="fw-bold">Loading, please wait...</div>
          </div>
        </div>
      )}

      {uploadLoading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0,0,0,0.3)", zIndex: 1050 }}>
          <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Uploading...</span>
            </div>
            <div className="fw-bold">Uploading, please wait...</div>
          </div>
        </div>
      )}
      <div className="w-100 d-flex align-items-end justify-content-center px-5 mt-2">
        <div className="w-100">
          <h2 className="my-3 mb-4">Proposal for permission for {heading} </h2>
          {(roleIdentifier === "SC" || roleIdentifier === "HOS" || roleIdentifier === "DT" || roleIdentifier === "DY"||roleIdentifier==="SA") &&
            getCertificates()}
          <div className="d-flex flex-column text-nightblue align-items-center justify-content-center  ">
            <div
              id="table"
              className="w-100 border overflow-hidden bg-white border-secondary rounded mb-3"
            >
              <div
                id="head"
                className="d-flex w-100  rounded-top border-secondary"
                style={{ backgroundColor: "#CCE3FF" }}
              >
                <h4 className="col-1 d-flex justify-content-center align-items-center">
                  S.No.
                </h4>
                <h4 className="col-4 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary">
                  પ્રશ્ન(Field)
                </h4>
                <div className="d-flex col-5">
    <h4
     className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
  (existData?.status !== "approve" && existData?.role===roleIdentifier&&roleIdentifier!=="SA"&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"))
    ? "col-6"
    : "col-12"
}`}

    >
      જવાબ (Response)
    </h4>

    {(existData?.status !== "approve" && existData?.role===roleIdentifier&&roleIdentifier!=="SA"&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission")) && (
      <h4 className="col-6 p-2 justify-content-center d-flex align-items-center">
        ક્રિયા (Action)
      </h4>
    )}
  </div>
                <h4 className="col-2 p-2 justify-content-center d-flex align-items-center  border-secondary">
                  Change History
                </h4>
              </div>
              {dataField &&
                dataField.length > 0 &&
                dataField.map((item, index) => {
                  // Highlight if any of the item's response fieldNames are present in SEC resubmittedFieldsData
                  const reSubmittedFieldsData = existData?.apmcSchemeTransaction?.reSubmittedFields?.resubmittedFieldsData?.annexureOne;
                  const isResubmittedField = reSubmittedFieldsData && item.response.some(r => Object.prototype.hasOwnProperty.call(reSubmittedFieldsData, r.fieldName));
                  return (
                    <React.Fragment key={index}>
                      <div className={`d-flex border-top border-secondary`}>
                        <h4 className="col-1 d-flex align-items-center justify-content-center">
                          {item.fieldNo}
                        </h4>
                        <div className="col-4 ">
                          <p className={`d-flex align-items-center h-100 p-3 border-start border-end border-secondary${isResubmittedField ? ' text-warning' : ''}`}>
                            {item.fieldVal}*
                          </p>
                        </div>

                        <div className="col-5 d-flex ">
                                      <div      className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
   (existData?.status!=="approve" && existData?.role===roleIdentifier&&roleIdentifier!=="SA"&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"))? "col-6" : "col-12"
      }`}>
                            <div className="w-75 d-flex flex-column p-2 gap-2 ">
                              {item.response.map((newObj, indx) => {
                                const docName = newObj.responseVal;
                                const fieldName = item.fieldName;

                                const inputKey = `${index}_${indx}`;
                                const divVal =
                                  newObj.responseType === "select"
                                    ? selectFn(newObj)
                                    : newObj.responseType === "input"
                                      ? inputFn(newObj)
                                      : newObj.responseType === "number"
                                        ? numberFn(newObj)
                                        : newObj.responseType === "radio"
                                          ? radioFn(newObj)
                                          : newObj.responseType === "percentage"
                                            ? percentageFn(newObj)
                                            : newObj.responseType === "date"
                                              ? dateFn(newObj)
                                              : newObj.responseType === "file"
                                                ? fileButtonFn(fieldName, docName)
                                                : null;
                                return (
                                  <div
                                    className=" d-flex align-items-center justify-content-center"
                                    key={inputKey}
                                  >
                                    {divVal}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                      { (existData?.status !== "approve" && existData?.role===roleIdentifier&&roleIdentifier!=="SA"&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"))  &&  <div className="col-6 d-flex justify-content-center align-items-center border-secondary border-end p-2">
                            <ActionButtons
                              fieldNo={`${index}`}
                              item={item}
                              verified={verified}
                              editFieldValues={editFieldValues}
                              editFiles={editFiles}
                              fieldComments={fieldComments}
                              updatedIndexes={updatedIndexes}
                              onVerifiedChange={handleVerifiedChange}
                              onEditingToggle={handleEditingToggle}
                              onFieldSubmit={handleUpdateSubmit}
                              onCommentChange={handleCommentChange}
                              ActionRequired={ActionRequired}
                              editingIndex={editingIndex}
                              pendingVerified={pendingVerified}
                            />
                          </div>}
                        </div>
                        <div className="col-2 d-flex p-2 gap-2 flex-column flex-lg-row align-items-center justify-content-center">
                          <div className="border rounded-3 ps-2">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip>
                                  See the edit history for this field
                                </Tooltip>
                              }
                            >
                              <i className="feather feather-info pe-2"></i>
                            </OverlayTrigger>

                            <button
                              className={`btn rounded-3 ms-2 ${item.response.some(r => (existData?.annexureOne?.[r.fieldName]?.transaction?.some((tx) => tx.isUpdated === true || tx.comment))) ? 'btn-danger ' : 'btn-light'}`}
                              style={item.response.some(r => (existData?.annexureOne?.[r.fieldName]?.transaction?.some((tx) => tx.isUpdated === true || tx.comment))) ? { backgroundColor: '#ffd6d6', color: '#a94442', borderColor: '#ffd6d6' } : {}}
                              onClick={() =>
                                handleViewLogClick(
                                  item.response.map((r) => r.fieldName)
                                )
                              }
                            >
                              View Log
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Edit Form */}
                      {editingIndex === index && (
                        <div className="d-flex flex-column border-top border-secondary bg-white p-3">
                          <h4 className="border-bottom border-3 border-success mb-3">
                            Edit Values
                          </h4>

                          {/* File Inputs */}
                          {/* File Inputs */}
                          <div className="d-flex gap-3 flex-wrap mb-3">
                            {item.response
                              .filter(
                                (r) =>
                                  r.responseType === "file" ||
                                  r.responseType === "button"
                              )
                              .map((r, fileIdx) => (
                                <div
                                  key={fileIdx}
                                  className="d-flex flex-column w-25"
                                >
                                  <label className="fw-semibold mb-1">
                                    {r.responseName || r.responseVal}
                                  </label>
                                  <div className="d-flex gap-2 align-items-center">
                                    <input
                                      className="form-control"
                                      type="file"
                                      onChange={(e) => {
                                        const file =
                                          e.target.files?.[0] || null;
                                        // handleEditFileChange(r.responseVal, file);
                                        handleFileChange(e, `${r.fieldName}`);
                                        // Add this line to track in updatedFields (you'll need to handle file upload)
                                        if (file) {
                                          setUpdatedFields((prev) => ({
                                            ...prev,
                                            [r.responseVal]: {
                                              file: file,
                                              documentName: r.responseVal,
                                            },
                                          }));
                                        }
                                      }}
                                      name={r.responseVal}
                                      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                                      key={
                                        editFiles[r.responseVal]
                                          ? "file-selected"
                                          : "file-empty"
                                      }
                                    />

                                  </div>
                                  {editFiles[r.responseVal] && (
                                    <small className="text-muted mt-1">
                                      Selected: {editFiles[r.responseVal]?.name}
                                    </small>
                                  )}
                                </div>
                              ))}
                          </div>
                          <div className="d-flex gap-3 flex-wrap mb-3">
                            {item.response
                              .filter(
                                (r) =>
                                  r.responseType === "radio"
                              )
                              .map((r, fileIdx) => (
                                <div
                                  key={fileIdx}
                                  className="d-flex flex-column w-25"
                                >
                                  <label className="fw-semibold mb-1">
                                    {r.responseName || r.responseVal}
                                  </label>
                                  <div className="d-flex gap-2 align-items-center">
                                    <input
                                      type="radio"
                                      name={r?.responseVal}
                                      value="yes"
                                      checked={editFieldValues[r?.fieldName]?.find(item => item.fieldName === r?.responseVal)?.value === "yes"}
                                      onChange={(e) => {
                                        handleInputChange(e, r?.fieldName);
                                        // setUpdatedFields((prev) => ({
                                        //                         ...prev,
                                        //                         [r.responseVal]: e.target.value,
                                        //                       }));
                                      }}

                                    />{" "}Yes
                                    <input
                                      type="radio"
                                      name={r?.responseVal}
                                      value="no"
                                      checked={editFieldValues[r?.fieldName]?.find(item => item.fieldName === r?.responseVal)?.value === "no"}
                                      onChange={(e) => {
                                        handleInputChange(e, r?.fieldName);
                                        //  setUpdatedFields((prev) => ({
                                        //                                 ...prev,
                                        //                                 [r.responseVal]: e.target.value,
                                        //                               }));
                                      }}

                                    />{" "}No
                                  </div>

                                </div>

                              ))}
                          </div>

                          {/* Other Input Types */}
                          <div className="d-flex gap-3 flex-wrap mb-3">
                            {item.response
                              .filter(
                                (r) =>
                                  !["file", "button", "radio"].includes(r.responseType)
                              )
                              .map((r, inputIdx) => (
                                <div
                                  key={inputIdx}
                                  className="d-flex flex-column w-25"
                                >
                                  <label className="fw-semibold mb-1">
                                    {r.responseName || r.responseVal}
                                  </label>
                                  <div className="d-flex gap-2 align-items-center">
                                    <input
                                      type={
                                        r.responseType === "number"
                                          ? "number"
                                          : r.responseType === "date"
                                            ? "date"
                                            : "text"
                                      }
                                      className="form-control"
                                      placeholder={`Enter ${r.responseVal}`}
                                      name={r.responseVal}
                                      value={
                                        editFieldValues[r?.fieldName]?.find(item => item.fieldName === r?.responseVal)?.value || ""
                                      }
                                      onChange={(e) => {
                                        handleInputChange(e, r.fieldName);
                                        setUpdatedFields((prev) => ({
                                          ...prev,
                                          [r.responseVal]: e.target.value,
                                        }));
                                      }}
                                    />

                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
          {roleIdentifier === "Dr" &&(existData?.status !== "approve" && existData?.role===roleIdentifier) && getCertificates()}
          {checkerr && <div className="text-danger mb-2">Please check the checkbox  to move Forward</div>}
          <div className="d-flex flex-column justify-content-between mb-4">
    { transaction && transaction.length>0 &&
              
              <Link
              to="#"
              data-bs-toggle="modal" data-inert={true}
              data-bs-target="#comment_modal"
              className="d-flex btn btn-primary align-items-center w-25 mb-4"
              >
                  <i className="me-2 ti ti-file-description" />
                  View Application Timeline
              </Link>     
               }

            <div className="d-flex justify-center justify-item-center w-100">
              {existData?.status === "approvedUnsigned" && roleIdentifier === "SC" && (
                <DownloadFormApplication
                  type={type}
                  existData={existData}
                  applicationId={applicationId}
                />
              )}
 
              {existData?.buttonName &&
                existData.buttonName.length > 0 &&
                existData.buttonName[0].appStatusLevel != "schemeGranted" &&
                existData.role !== "" &&
                roleIdentifier === existData.role && (
                  <div className="w-100 d-flex gap-2 flex-column">
                    {!(
                      (["JC"].includes(existData.role) &&
                        existData.appStatusLevel ==
                        "dclerkAfterRejectionAction") ||
                      (["HJC"].includes(existData.role) &&
                        existData.appStatusLevel ==
                        "hoclerkAfterRejectionAction")
                    ) && <div></div>}
                        <textarea
                    className="form-control mb-3"
                    placeholder="Enter your comment"
                    name="currAt"
                    value={comment!=""? comment : ""} // Bind value to state
                    onChange={(e) => setComment(e.target.value)} // Update state on type
                    rows={4} // Adjust number of rows as needed
                    // maxLength={100}
                  />
                    <div className="d-flex gap-2">
                      {existData.buttonName &&
                        existData?.buttonName.map((button) => (
                          <button
                            key={button.status}
                            className={`btn ${button.status === "reject"
                                ? "btn-danger"
                                : button.status === "permanentReject"
                                  ? "btn-secondary"
                                  : "btn-success"
                              }`}
                            onClick={() => {
                              handleFinalSubmit(
                                button.status,
                                button.appStatusLevel
                              );
                            }}
                          >
                            {button.buttonLabel === "Forward to senior clerk for forwarding to Higher Authority" ? "Approve" : button.buttonLabel}
                          </button>
                        ))}
                    </div>
                  </div>
                )}
            </div>

          </div>
               <div className="row p-3">
                                                {existData && existData.status == "approve" && (
                                                  <div className="col-sm-12 d-flex justify-content-end">
                                                    {/* <button
                                                      onClick={() => {
                                                        handleDownload();
                                                      }}
                                                      className="bg-success rounded text-white px-4 py-2"
                                                    >
                                                      {language.download_license}
                                                    </button> */}
                      
                                                     {(() => {
                                                      const latestLicense = existData?.licDoc // Get the last license
                      
                                                      return latestLicense ? (
                                                        <Link
                                                          key={latestLicense}
                                                          to="#"
                                                          data-bs-toggle="modal"
                                                          data-inert={true}
                                                          data-bs-target="#apmc_modal"
                                                          className="btn btn-success align-items-center"
                                                          onClick={() => setSelectedDocId(latestLicense)}
                                                        >
                                                          Download License
                                                        </Link>
                                                      ) : null;
                                                    })()}
                                                  </div>
                                                )}
                                              </div>
        </div>
      </div>
      {showLogOverlay && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 1055 }}
        >
          <div
            className="bg-white p-4 rounded shadow position-relative overflow-auto"
            style={{ minWidth: "70%", maxHeight: "90%", maxWidth: "800px" }}
          >
            <button
              className="position-absolute top-0 end-0 m-3 btn-close"
              onClick={handleCloseOverlay}
            />

            <div className="d-flex align-items-center gap-2 mb-3">
              <i className="ti ti-history"></i>
              <h4 className="mb-0">Change History -  {dataField.find(f => f.fieldName === logFieldKey)?.fieldLabel || logFieldKey}</h4>
            </div>

            {/* Transaction Section */}
            {transactionData?.length > 0 && (
              <div className="mt-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="ti ti-report"></i>
                  <h5 className="mb-0">Transaction History</h5>
                </div>

                {transactionData.map((txItem, idx) => (
                  <div key={idx} className="mb-4">
                    <div className="badge bg-info mb-2">
                      {dataField.find(f => f.fieldName === txItem.key)?.fieldLabel || txItem.key}
                    </div>

                    {txItem.data.length === 0 ? (
                      <div className="text-muted">No transaction found.</div>
                    ) : (
                      txItem.data.map(
                        (entry, i) => (
                      
                          (
                            <div
                              key={i}
                              className="border-start border-info border-3 p-3 mb-3 bg-light-subtle rounded"
                            >
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <strong>
                                  Modified By:{" "}
                                  {(() => {
                                    const role = roleOptions.find(
                                      (option) => option.value === entry.transactionBy
                                    );
                                  
                                    return role?.label || "Unknown";
                                  })()}
                                </strong>
                                <small className="text-muted">
                                  📅 {entry.createdAt || "-"}
                                </small>
                              </div>
                              {entry.oldValue.length > 0 && entry.newValue.length > 0 && <div className="d-flex align-items-center gap-2 mb-2">
                                <span className="text-danger">Old Data:</span>
                                <div className="d-flex flex-column gap-1">
                                  {Array.isArray(entry.oldValue) ? (
                                    entry.oldValue.map((item, i) =>
                                      typeof item === "object" &&
                                        item.fieldType === "doc" ? (
                                        <div
                                          key={i}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <span className="badge bg-secondary">
                                            {responseMap[item?.fieldName] || item?.fieldName}
                                          </span>
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#apmc_modal"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() =>
                                              setSelectedDocId(item.fieldValue)
                                            }
                                          >
                                            <i className="ti ti-eye"></i> View
                                            Document
                                          </Link>
                                        </div>
                                      ) : (
                                        <>
                                          <span className="badge bg-secondary">
                                            {responseMap[item?.fieldName] || item?.fieldName}
                                          </span>
                                          <span
                                            key={i}
                                            className="badge bg-danger-subtle text-danger"
                                          >
                                            {typeof item === "object"
                                              ? item.fieldValue
                                              : item}
                                          </span></>

                                      )
                                    )
                                  ) : (
                                    <>
                                      <span className="badge bg-secondary">
                                        {responseMap[entry.oldValue.fieldName]}
                                      </span>
                                      <span className="badge bg-danger-subtle text-danger">
                                        {entry.oldValue.fieldValue}
                                      </span></>

                                  )}
                                </div>
                                <i className="ti ti-arrow-right"></i>
                                <span className="text-danger">
                                  Updated Data:
                                </span>

                                <div className="d-flex flex-column gap-1">
                                  {Array.isArray(entry.newValue) ? (
                                    entry.newValue.map((item, i) =>
                                      typeof item === "object" &&
                                        item.fieldType === "doc" ? (
                                        <div
                                          key={i}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <span className="badge bg-success">
                                            {responseMap[item?.fieldName] || item?.fieldName}
                                          </span>
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#apmc_modal"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() =>
                                              setSelectedDocId(item.fieldValue)
                                            }
                                          >
                                            <i className="ti ti-eye"></i> View
                                            Document
                                          </Link>
                                        </div>
                                      ) : (
                                        <>
                                          <span className="badge bg-success">
                                            {responseMap[item?.fieldName] || item?.fieldName}
                                          </span>
                                          <span
                                            key={i}
                                            className="badge bg-danger-subtle text-danger"
                                          >
                                            {typeof item === "object"
                                              ? item.fieldValue
                                              : item}
                                          </span></>

                                      )
                                    )
                                  ) : (<>
                                    <span className="badge bg-success">
                                      {responseMap[entry.newValue.fieldName]}
                                    </span>
                                    <span className="badge bg-danger-subtle text-danger">
                                      {entry.newValue.fieldValue}
                                    </span>
                                  </>
                                  )}
                                </div>
                              </div>}
                              {entry.isVerified && (
                                <div className="d-flex align-items-center gap-2 mb-2">
                                  <span className="text-success">Verified:</span>
                                  <i className="ti ti-check text-success"></i>

                                  <span className="text-success">
                                    {entry.isVerified === true ? "Yes" : "No"}
                                  </span>
                                </div>
                              )}
                              {entry.comment && (
                                <div className="bg-primary-subtle text-dark rounded p-2 d-flex align-items-start gap-2">
                                  <i className="ti ti-message mt-1"></i>
                                  <span>{entry.comment}</span>
                                </div>
                              )}
                              <div className="d-flex align-items-center gap-2 mb-2">
                                <span className="text-muted">Status:</span>
                                <span className="badge bg-warning-subtle text-dark fs-14">
                                  {entry.status}
                                </span>
                              </div>

                            </div>
                          )
                        )
                      )
                    )}
                  </div>
                ))}
              </div>
            )}

          </div>
        </div>
      )}
      <SingleView docId={selectedDocId} type="form" datafield={dataField} />
      <ApplicationTimelineModal comments={transaction} />
      <ToastContainer autoClose={3000} />
      {/* <ApplicationTimelineModal comments={transaction} /> */}
    </>
  );
};

export default Page1;

